import React, { useEffect, useState } from 'react'
import TeamsDetails from "../components/TeamsDetails/TeamsDetails.jsx";
import Header from "../components/Header/Header.jsx";
import Footer from "../components/Footer/Footer.jsx";
import axios from "axios";
import qs from "qs";

export default function Teams({setActiveCategory, teamsData}) {

    console.log(teamsData);

    return (
        <div>
            <Header pageTeam={true} setActiveCategory={setActiveCategory}/>
            <TeamsDetails teamsData={teamsData}/>
            <Footer pageTeam={true}/>
        </div>
    )
}
